import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import NavBar from "../components/NavBar";
import MICEDetails from "../components/MICEDetails";

const MICE = () => {
  return (
    <>
      {/* Navigation Bar */}
      <NavBar />

      {/* Navigation Bar */}
      <Breadcrumb title={"MICE"} />

      {/* Service Details Area */}
      <MICEDetails />
      


      {/* Footer One */}
      <FooterOne />
    </>
  );
};

export default MICE;
